import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class RmZonesDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "Zone id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Zone Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Zone id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  rmZoneId: number;
  @ApiProperty()
  @MaxLength(20, { message: "Zone Code allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Zone Code should be only alpha numeric" })
  rmZoneCode: string;
  @ApiProperty()
  @MaxLength(30, { message: "Zone Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Zone name should be only alpha numeric" })
  rmZoneName: string;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty()
  @IsNumber()
  plantId : number;
  @ApiProperty()
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Zone name should be only alpha numeric" })
  plantName: string;
}

